// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"styles_promoBanner__yBtpj","inner":"styles_inner__MpVYJ","image":"styles_image___knB9"};